import React, {useEffect} from 'react';
import ReportUtils from "../../../../../../utils/report-utils.js";
import NoDataRow from "../../../../../../components/reports/no-data-row.jsx";

const ApprehensionsTypeContent = ({ data }) => {
    const apprehensions = data?.apprehension_type ?? [];

    useEffect(() => {
        if (!apprehensions?.length) return;
        const values = [];

        apprehensions.map((element) => {
            values.push([
                element.type,
                element.qty
            ]);
        })

        ReportUtils.createExportableTable(["Tipo", "Quantidade"], values, 'Apreensões por tipo');
    }, [data]);

    return (
        <>
            <div className="mt-4 print:break-inside-avoid">
                <span className="chart-title mb-2">Apreensões por tipo e quantidade</span>
                <table id="encounter-by-reason-data" className="table report-table mt-2" sheet-name="Abordagens por natureza">
                    <thead className="thead-background">
                        <tr className="text-left">
                            <th className="w-[85%]">Tipo</th>
                            <th className="w-[15%]">Quantidade</th>
                        </tr>
                    </thead>

                    <tbody>
                        { !apprehensions?.length ? (
                            <NoDataRow colSpan={2} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : apprehensions.map((element, index) => (
                            <tr key={index}>
                                <td className="w-[85%]">{element.type}</td>
                                <td className="w-[15%]">{element.qty}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        </>
    );
};

export default ApprehensionsTypeContent;